import get from 'lodash/get';
import compact from 'lodash/compact';
import head from 'lodash/head';
import groupBy from 'lodash/groupBy';
import qs from 'query-string';
import { isNullOrUndefined } from 'dash-front/helpers';
import { marketDisplayName, SINGLE_OPTION_MARKETS, emptyValue } from './constants';
import BookieDL from '../../../widgets/helpers/BookieDeeplinker';

export const getTeamNames = event => {
    return event && typeof event === 'object'
        ? { homeName: event.homeName, awayName: event.awayName, drawName: 'Draw' }
        : { homeName: 1, awayName: 2, drawName: 'X' };
};

const buildUrl = (url, queryString) => {
    let resultUrl;
    if (url.indexOf('#s_') > -1) {
        //138 odds specific deeplink param
        let _url = url.split('#s_');
        resultUrl = _url[0] + '?' + queryString + '#s_' + _url[1];
    } else {
        resultUrl = url + '?' + queryString;
    }
    return resultUrl;
};

// deprecated
export const getCommonOutcomeText = (market, outcomes, event) => {
    if (market === 'btts') {
        const yes = outcomes['true'].odds;
        const no = outcomes['false'].odds;
        return `${marketDisplayName[market] || market} Yes: ${yes}, No: ${no}`;
    }
    const { homeName, awayName, drawName } = getTeamNames(event);
    if (SINGLE_OPTION_MARKETS.indexOf(market) > -1) {
        const value1 = get(outcomes, [1, 'odds']);
        const value2 = get(outcomes, [2, 'odds']);
        const valueX = get(outcomes, ['X', 'odds']);
        let outcomeText = '';
        if (!isNullOrUndefined(value1) && !isNullOrUndefined(value2)) {
            if (!isNullOrUndefined(valueX)) {
                outcomeText = `${homeName}: ${value1}, ${drawName}: ${valueX}, ${awayName}: ${value2}`;
            } else {
                outcomeText = `${homeName}: ${value1}, ${awayName}: ${value2}`;
            }
        }
        return `${marketDisplayName[market] || market} ${outcomeText}`;
    }
};

export const getUrlWithCampaign = (url, socialCampaigns, selectedCampaign) => {
    if (!url || !Array.isArray(socialCampaigns) || !selectedCampaign || selectedCampaign === emptyValue) {
        return url;
    }
    const selectedCampaignObj = socialCampaigns.find(i => i._id === selectedCampaign);
    const params = get(selectedCampaignObj, 'keys', []).reduce((acc, cur) => {
        acc[cur.key] = cur.value;
        return acc;
    }, {});
    const { query, url: deeplinkUrl } = qs.parseUrl(url);
    const queryString = qs.stringify({ ...query, ...params });

    let deeplinkedUrl = buildUrl(deeplinkUrl, queryString);
    const template = get(selectedCampaignObj, 'customUrl');
    return typeof template === 'string' ? template.replace('${url}', deeplinkedUrl) : deeplinkedUrl;
};

export const resolveOutcomeText = (outcome, event) => {
    if (!outcome) {
        return '';
    }
    switch (String(outcome.type)) {
        case '1': {
            return get(event, 'homeName', '1');
        }
        case '2': {
            return get(event, 'awayName', '2');
        }
        case 'X': {
            return 'Draw';
        }
        case 'true': {
            return 'Yes';
        }
        case 'false': {
            return 'No';
        }
        default: {
            const value = !isNullOrUndefined(outcome.value) ? ` ${outcome.value}` : '';
            return outcome.type + value;
        }
    }
};

export const getUrlAndText = ({ selectedOrder, outcomes, betOffers, event, selectedProvider }) => {
    if (
        selectedOrder.length === 0 ||
        [selectedOrder, outcomes, betOffers, selectedProvider, event].some(isNullOrUndefined)
    ) {
        return { url: null, text: null };
    }

    const isSingleChoice = selectedOrder.length === 1;
    const firstOutcome = outcomes[head(selectedOrder)];
    const betOfferRef = get(firstOutcome, 'internalBetofferId');
    const betOffer = get(betOffers, betOfferRef);
    let url = null;
    try {
        url = BookieDL.deeplink(selectedProvider, betOffer, isSingleChoice ? firstOutcome : null, 10);
    } catch (e) {
        url = BookieDL.deeplink(selectedProvider, betOffer, firstOutcome, 10);
    }

    const byMarket = groupBy(
        selectedOrder.map(item => {
            const { internalBetofferId, ...rest } = outcomes[item];
            return {
                market: betOffers[internalBetofferId].market.type,
                ref: item,
                ...rest
            };
        }),
        'market'
    );

    const text = Object.entries(byMarket).reduce((accStr, [market, outcomeItems], i) => {
        const withNewLine = market === 'score' || market === 'goals';
        const spacer = withNewLine ? '\n' : ' ';
        accStr += (marketDisplayName[market] || market) + ':' + spacer;
        outcomeItems.forEach((outcome, index) => {
            const resolvedText = resolveOutcomeText(outcome, event) + ': ' + outcome.odds;
            accStr += resolvedText + (index === outcomeItems.length - 1 ? '' : spacer);
        });
        return accStr + '\n';
    }, '');

    return { url, text };
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/odds/utils.js
 **/